var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-allocation-workspace',{key:_vm.slotType,attrs:{"slotType":_vm.slotType,"editable":true}})}
var staticRenderFns = []

export { render, staticRenderFns }